<div class="fc-file-list" *ngIf="files.length">
  <div class="fc-file-row" *ngFor="let file of files; let i = index; trackBy: trackByKey">
    <svg class="fc-file-row__icon" width="24" height="24" viewBox="0 0 36 36" fill="none" aria-hidden="true">
      <path d="M21 3H9a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V12L21 3z" stroke="#4589ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M21 3v9h9" stroke="#4589ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="fc-file-row__name" [title]="file.name">{{ file.name }}</span>
    <div class="fc-file-row__actions">
      <button type="button" class="fc-file-row__btn" [disabled]="busy" (click)="openPreview(file)">
        {{ labels.preview }}
      </button>
      <button
        type="button"
        class="fc-file-row__btn"
        *ngIf="showDownload"
        [disabled]="busy"
        (click)="downloadFile(file)"
      >
        {{ labels.download }}
      </button>
      <button
        type="button"
        class="fc-file-row__btn fc-file-row__btn--remove"
        *ngIf="!readOnly"
        [disabled]="busy"
        (click)="removeFile(i)"
      >
        {{ labels.remove }}
      </button>
    </div>
  </div>
</div>

<div class="fc-file-rejected" *ngFor="let item of rejected">
  <strong>{{ item.name }}</strong> — {{ item.reason }}
</div>

<div
  class="fc-dropzone"
  *ngIf="!readOnly"
  [class.fc-dropzone--over]="isDragging"
  [class.fc-dropzone--error]="showRequiredError"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <input
    #fileInput
    type="file"
    class="fc-dropzone__input"
    [accept]="acceptAttr"
    [multiple]="multiple"
    [disabled]="busy"
    (change)="onFileChange($event)"
  >

  <svg class="fc-dropzone__illustration" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="60" cy="60" r="55" stroke="#D0D5DD" stroke-width="1.5"/>
    <rect x="38" y="32" width="36" height="44" rx="3" stroke="#BCC0C8" stroke-width="1.5"/>
    <path d="M62 32v12h12" stroke="#BCC0C8" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M60 72V52M53 59l7-7 7 7" stroke="#BCC0C8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

  <span class="fc-dropzone__text" *ngIf="!uploading">{{ labels.dropzone }}</span>
  <span class="fc-dropzone__text" *ngIf="uploading">{{ labels.uploading }}</span>

  <button
    type="button"
    class="fc-dropzone__browse"
    [disabled]="busy"
    (click)="fileInput.click()"
  >
    {{ labels.browse }}
  </button>
</div>

<span class="fc-field__error" *ngIf="showRequiredError && showRequiredLabel">*Required</span>
